module.exports = __webpack_public_path__ + "img/vid_3_splash.4f73591a.jpg";